import { __assign, __rest } from "tslib";
import Calendar from '@mos-cat/calendar';
import PopoverWrapper from '@mos-cat/popover-wrapper';
import * as React from 'react';
function CalendarPopover(props) {
    var opened = props.opened, position = props.position, className = props.className, children = props.children, restProps = __rest(props, ["opened", "position", "className", "children"]);
    return (React.createElement(PopoverWrapper, { open: opened, position: position, className: className, content: React.createElement("div", { className: "Datepicker__popover" },
            React.createElement(Calendar, __assign({ className: "Datepicker__calendar" }, restProps))) }, children));
}
export default CalendarPopover;
//# sourceMappingURL=Calendar.js.map